import React, { useContext, useEffect, useState } from 'react';
import { Col, Row, Form, Select, message } from 'antd';
import './style.scss';
import { WorkflowContext, StepContext } from '../../Commons/Context';
import {isObject, keys as keycreate} from 'lodash';
import { PrimaryButton } from '../../Commons';
import { requiredRule, flatten } from '../../Commons/utils';
import { fetchXeroAccounts, fetchXeroBrandingTheme, fetchXeroCurrencies, fetchXeroItems, fetchXeroOrgs, fetchXeroTaxRates } from '../../Http/xero';
import { creditNoteLineAmountTypes, creditNoteStatusCode, creditNoteTypes, XeroSentToContactOpt } from '../../Http/models/xero/XeroConstants';

const CreditNoteForm = () => {
  const { sampleData, sampleData2, setActionData, mappings, setMappings, setOrganisation, additionalQuery, setAdditionalQuery, form } = useContext(WorkflowContext);
  const { id, next } = useContext(StepContext);

  const [keys, setKeys] = useState([]);
  const [keys2, setKeys2] = useState([]);
  const [accountOpt, setAccountOpt] = useState([]);
  const [currencyOpt, setCurrencyOpt] = useState([]);
  const [brandingThemeOpt, setBrandingThemeOpt] = useState([]);
  const [itemCodeOpt, setItemCodeOpt] = useState([]);
  const [taxRatesOpt, setTaxRatesOpt] = useState([]);
  const [organisations, setOrganisations] = useState([]);
  const [returnMap, setReturnMap] = useState(false);

//   const sentToContactOpt = [
//     { label: 'True', value: true },
//     { label: 'False', value: false },
//   ];

//   const lineAmountTypesOpt = [
//     { label: 'EXCLUSIVE', value: 'Exclusive' },
//     { label: 'INCLUSIVE', value: 'Inclusive' },
//     { label: 'NOTAX', value: 'NoTax' },
//   ];

//   const statusOpt = [
//     { label: 'DRAFT', value: 'DRAFT' },
//     { label: 'SUBMITTED', value: 'SUBMITTED' },
//     { label: 'AUTHORISED', value: 'AUTHORISED' },
//   ];

  // useEffect(() => {
  //   setKeys(keycreate(sampleData));
  //   if(sampleData2){
  //     setKeys2(keycreate(sampleData2));
  //   }

  // }, []);
  useEffect(() => {
    if(sampleData){
      setKeys(keycreate(sampleData));
    }
    if(sampleData2){
      setKeys2(keycreate(sampleData2));
    }
    // Restore input fields by source order: 1 is the parent, 2 is a child record.
    // Reply mappings store the parent destination field in value, unlike ACT mappings.
    const values = {};
    (mappings || []).filter(mapping => String(mapping.stepId) === String(id)).forEach(mapping => {
      if (mapping.type === 'TRIG') values[mapping.field] = [mapping.valueStepOrder + '.' + mapping.value];
      else if (mapping.type === 'ACT') values[mapping.value] = [mapping.valueStepOrder + '.' + mapping.field];
      else if (['LOG', 'LOGM', 'LOGS'].includes(mapping.type)) values[mapping.type] = ['1.' + mapping.value];
      else if (mapping.type === 'CON') values[mapping.field] = mapping.value;
    });
    form.setFieldsValue(values);
  }, [sampleData, sampleData2, mappings, id, form]);

  useEffect(() => {
    fetchAccountOpt();
    fetchCurrencyOpt();
    fetchBrandingThemeOpt();
    fetchItemCodeOpt();
    fetchTaxRatesOpt();
    fetchOrganisations();
  }, []);

  const fetchAccountOpt = async () => setAccountOpt(await (await fetchXeroAccounts()).data);
  const fetchCurrencyOpt = async () => setCurrencyOpt(await (await fetchXeroCurrencies()).data);
  const fetchBrandingThemeOpt = async () => setBrandingThemeOpt(await (await fetchXeroBrandingTheme()).data);
  const fetchItemCodeOpt = async () => setItemCodeOpt(await (await fetchXeroItems()).data);
  const fetchTaxRatesOpt = async () => setTaxRatesOpt(await (await fetchXeroTaxRates()).data);
  const fetchOrganisations = async () => setOrganisations(await (await fetchXeroOrgs()).data);

  const handleSubmit = () => {
    if (!sampleData || !sampleData2 || !additionalQuery) {
      message.error('Select and test the parent and child Salesforce objects first.');
      return;
    }
    form
      .validateFields()
      .then((rawFormData) => {
        let ACTION_DATA = {}; //Data to be send as a product of the trigger
        let MAPPINGS = [];

        let flatFormData = flatten({ ...rawFormData }); // add invoice type then flatten



        keycreate(flatFormData)
          .filter((k) => flatFormData[k] && !Array.isArray(flatFormData[k]))
          .map((key) => {
            const selected = String(flatFormData[key]);
            const source = selected.match(/^([12])\.(.+)$/);
            const kname = source ? source[2] : selected;
            const snum = source ? Number(source[1]) : undefined;

            // Reply mappings are saved for Salesforce only, never sent to Xero.
            if (['LOG', 'LOGM', 'LOGS'].includes(key)) {
              const replyField = { LOG: 'CreditNoteResponse', LOGM: 'CreditNoteMessage', LOGS: 'CreditNoteStatus' }[key];
              MAPPINGS.push({ type: key, field: replyField, value: kname, stepId: id, valueStepOrder: 1 });
              return;
            }
            let kval = snum && parseInt(snum) === 1 ? sampleData[kname] 
                     : snum && parseInt(snum) === 2 ? sampleData2[kname]
                     : kname;

            ACTION_DATA = { ...ACTION_DATA, [key]: kval };
            MAPPINGS = snum ? 
                            (key === 'CreditNoteID' || key === 'LineItemID')
                              ?
                              [...MAPPINGS, { type: 'ACT', field: kname, value: key, stepId: id, valueStepOrder: snum }]
                              :
                              [...MAPPINGS, { type: 'TRIG', field: key, value: kname, stepId: id, valueStepOrder: snum }] 
                            : 
                            (key === 'CreditNoteID' || key === 'LineItemID')
                              ?
                              [...MAPPINGS, { type: 'ACT', field: kname, value: key, stepId: id, valueStepOrder: snum }]
                              :
                              [...MAPPINGS, { type: 'CON', field: key, value: kname, stepId: id }];
          });
        
        // Query every mapped child source and return-ID field once; constants
        // and parent reply fields must not become child SELECT columns.
        const childFields = [...new Set(['Id', ...MAPPINGS.filter(mapping => mapping.valueStepOrder === 2)
          .map(mapping => mapping.type === 'ACT' ? mapping.field : mapping.value)])];
        setAdditionalQuery(additionalQuery.replace(/SELECT\+.*?\+FROM\+/i, 'SELECT+' + childFields.join(',') + '+FROM+'));
        delete ACTION_DATA.LineItemID;
        setActionData(ACTION_DATA);
        setMappings(MAPPINGS);
        next();
      })
      .catch((e) => console.log(e));
  };

  const RoundedSelect = (props) => {
    const { label, placeholder, name, required, specialOptions, specialOptionsOnly, hint, onSelect, sourceOrder } = props;

    return (
      <Col span={22}>
        <div className='label'>
          {label} <span className={required ? 'fr' : 'hidden'}>(required)</span>
        </div>
        <Form.Item name={name} required={required} dependencies={['LOG', 'LOGM', 'LOGS', 'CreditNoteID']} rules={[
          ...(['LOG', 'LOGM', 'LOGS'].includes(name) ? [{ validator: (_, value) => {
            const selected = Array.isArray(value) ? value[0] : value;
            if (!selected) return Promise.resolve();
            const idField = form.getFieldValue('CreditNoteID')?.[0];
            const otherReplyFields = ['LOG', 'LOGM', 'LOGS'].filter(type => type !== name)
              .map(type => form.getFieldValue(type)?.[0]);
            return selected !== idField && !otherReplyFields.includes(selected)
              ? Promise.resolve() : Promise.reject(new Error('Use a separate Salesforce field for each reply value.'));
          } }] : []),
          ...(required ? [requiredRule] : []),
          ...(sourceOrder ? [{ validator: (_, value) => {
            const selected = Array.isArray(value) ? value[0] : value;
            const sample = sourceOrder === 1 ? sampleData : sampleData2;
            return !selected || ((Array.isArray(value) ? value.length === 1 : true) && String(selected).startsWith(sourceOrder + '.') && Object.prototype.hasOwnProperty.call(sample || {}, String(selected).slice(2)))
              ? Promise.resolve() : Promise.reject(new Error('Select a field from the correct Salesforce object.'));
          } }] : []),
        ]}>
          <Select className='rounded' mode={specialOptions ? null : 'tags'} 
                  placeholder={placeholder} allowClear onSelect={onSelect}>

            {specialOptions && specialOptions.map((v) => <Select.Option key={v.value} value={v.value}>{v.label}</Select.Option>)}

            {!specialOptionsOnly && sourceOrder !== 2 &&
              keys.map(
                (v, k) =>
                  !isObject(sampleData[v]) && (
                    <Select.Option value={`1.${v}`} key={`1.${k}`}>
                      <div className='opt-div'>
                        <span className='key'>{`1.${v}:  `}</span>
                        {`${sampleData[v]}`}
                      </div>
                    </Select.Option>
                  )
              )}

              {!specialOptionsOnly && sourceOrder !== 1 &&
              keys2.map(
                (v, k) =>
                  !isObject(sampleData2[v]) && (
                    <Select.Option value={`2.${v}`} key={`2.${k}`}>
                      <div className='opt-div'>
                        <span className='key'>{`2.${v}:  `}</span>
                        {`${sampleData2[v]}`}
                      </div>
                    </Select.Option>
                  )
              )}
          </Select>
        </Form.Item>
        {hint && <div className='hint'>{hint}</div>}
      </Col>
    );
  };

  const onChange = (event) => {
    //console.log({event, form: form.getFieldsValue()});
  };

  return (
    <Row className='padded xinvform'>
      <div className='title'>Customize Credit Note</div>
      <Col span={24}>
        <Row hidden={returnMap} justify='center'>
          <RoundedSelect
            label='Organisation'
            name='Organisation'
            required={true}
            placeholder='Choose value'
            specialOptions={organisations}
            specialOptionsOnly={true}
            onSelect={(v) => {
              setOrganisation(v);
            }}
          />
        </Row>

        <Form layout='vertical' form={form} scrollToFirstError={true} onFinish={handleSubmit} onValuesChange={onChange}>
          <Row hidden={returnMap} justify='center'>
            <RoundedSelect label='Type' hint='Credit note type.' name='Type' placeholder='Choose value..' specialOptions={creditNoteTypes()} />
            <RoundedSelect label='Contact ID' name='Contact.ContactID' required={true} placeholder='Type or insert..' />
            <RoundedSelect label='Email Address' name='Contact.EmailAddress' placeholder='Type or insert..' />
            <RoundedSelect label='Date' hint='Defaults to creation date if not specified.' name='Date' placeholder='Type or insert..' />
            <RoundedSelect label='Status' hint='Defaults to Draft if not specified.' name='Status' placeholder='Choose value..' specialOptions={creditNoteStatusCode()} />
            <RoundedSelect label='Credit Note Number' hint='Unique & Non-unique alpha numeric code identifying credit note(for reference).' name='CreditNoteNumber' placeholder='Choose value..' />
            <RoundedSelect label='Currency' hint='Default currency for organization will be used if not specified.' name='CurrencyCode' placeholder='Choose value..' specialOptions={currencyOpt} />
            <RoundedSelect label='Branding Theme' hint='The branding theme to use for this invoice.' name='BrandingThemeId' placeholder='Choose value..' specialOptions={brandingThemeOpt} />
            {/* <RoundedSelect label='Due Date' hint='A due date is required for approved invoices.' name='DueDate' placeholder='Type or insert..' />
            <RoundedSelect label='URL' name='Url' hint='URL link to a source document.' placeholder='Type or insert..' />
            <RoundedSelect label='Number' name='InvoiceNumber' hint='Unique alpha numeric code identifying invoice - leave blank for auto-generated value.' placeholder='Type or insert..' /> */}

            <RoundedSelect label='Reference' name='Reference' hint='An additional reference number' placeholder='Type or insert..' />
            <RoundedSelect
              label='Sent to Contact'
              hint="Mark invoice as 'sent' (note: does not actually send an email). This can be set only on invoices that have a status of 'approved' You can set this in the Status field above."
              name='SentToContact'
              placeholder='Type or insert..'
              specialOptions={XeroSentToContactOpt()}
            />
            <RoundedSelect
              label='Line Items Type'
              hint="Line amounts are exclusive of tax by default if you don't specify this element."
              name='LineAmountTypes'
              placeholder='Choose value..'
              specialOptions={creditNoteLineAmountTypes()}
            />
          </Row>

          <fieldset hidden={returnMap} className='fieldset' style={{ border: '1px solid #e2e2e2' }}>
            <legend>Line Items</legend>
            <Row justify='center'>
              <RoundedSelect label='Item Code' hint='You must provide either an Item Code or both a Description and a Unit Price.' name='LineItems[0].ItemCode' placeholder='Choose value..' specialOptions={itemCodeOpt} />
              <RoundedSelect label='Description' hint='If no Item Code is provided, this field is required.' name={'LineItems[0].Description'} placeholder='Type or insert..' />
              <RoundedSelect label='Quantity' name='LineItems[0].Quantity' required={true} placeholder='Type or insert..' />
              <RoundedSelect label='Unit Price' hint='If no Item Code is provided, this field is required.' name='LineItems[0].UnitAmount' required={true} placeholder='Type or insert..' />
              <RoundedSelect label='Discount%' name='LineItems[0].DiscountRate' placeholder='Type or insert..' />
              <RoundedSelect label='Account' name='LineItems[0].AccountCode' placeholder='Choose value..' specialOptions={accountOpt} />
              <RoundedSelect
                label='Tax Rate'
                hint='Only specify if you want to override the default tax type for the account above.'
                name={['LineItems[0].TaxType']}
                placeholder='Choose value..'
                specialOptions={taxRatesOpt}
              />

              {/* <RoundedSelect label='Tracking' name='tracking' required={false} placeholder='Type or insert..' /> */}
            </Row>
          </fieldset>

          <PrimaryButton hidden={returnMap} className='btn-long' size='large' htmlType='button' onClick={()=>setReturnMap(true)}>
            Continue
          </PrimaryButton>

          <Row hidden={!returnMap} justify='center'>

            <Col span={22}><h3>Reply back to Salesforce</h3><p>Save the returned IDs and optional results on the parent Salesforce record.</p></Col>
            <RoundedSelect label='Parent Credit Note ID' name='CreditNoteID' sourceOrder={1} required={true} placeholder='Select a parent Salesforce field' />
            <RoundedSelect label='Child Line Item ID' name='LineItemID' sourceOrder={2} placeholder='Select a child Salesforce field (optional)' />
            {/* Reply values use parent fields so one result is saved per credit note. */}
            <RoundedSelect label='Full log' name='LOG' sourceOrder={1} hint='Optional. Saves the complete response or error details for troubleshooting, up to 131,072 characters. Use a long text field.' placeholder='Select a parent Salesforce text field' />
            <RoundedSelect label='Result status' name='LOGS' sourceOrder={1} hint='Optional. Saves SUCCESS or ERROR so you can see the outcome at a glance.' placeholder='Select a parent Salesforce text field' />
            <RoundedSelect label='Result message' name='LOGM' sourceOrder={1} hint='Optional. Saves the specific Xero validation error, or the response message or status on success.' placeholder='Select a parent Salesforce text field' />
            <PrimaryButton hidden={!returnMap} className='btn-long' size='large' htmlType='submit'>
              Continue
            </PrimaryButton>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default CreditNoteForm;
